import {React} from "react";
import   "../pages/styles.css";
import  davidDick from "../images/InMemorium/DavidDick.jpg"
import TextImage from "../Common/TextImage";
import ImageText from "../Common/ImageText"
import  michaelLong from "../images/InMemorium/MichaelLong.jpg"



const AboutUs = () => {

     return (
<div style={{background:"#eceff3f6"}}>
          <h1 className="boldFancyHeadFontCenter">In Honor of Our Missing Members</h1>
          <h2 className="boldFancyHeadFontCenter2">Here we dedicate space to members moved on</h2>
          
     <br></br>
     <br></br>
     <br></br>
     <br></br>
     <br></br>
  
      <div className={`whiteFancyHeadFontCenter`} >
        <h2>David Dick</h2>
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <TextImage 
          selImage={davidDick}
          myText="It is with saddened hearts that Kermis Club says good-bye to one of its long-standing members, David Dick.|
          David and his wife Benita were Kermis Club’s Sponsor at Northwood Club for many years, as well as having served as 
          President and Board Member.   |
          In addition to Kermis Club, David took on leadership roles in numerous organizations, including President of 
          East Dallas Rotary Club and President of Knife and Fork. He also enjoyed golf, hunting, was a great chef, 
          and prepared many delicious meals for family and friends. |
          With his wife Benita, David especially enjoyed dancing and socializing at Kermis Club dinner-dances. 
          Even when no longer President or on the Board, he made it a point to speak to everyone at every table. 
          People would frequently ask Benita, “Where is David?”, and her standard reply was, 'He is working the crowd 
          like a politician!'. |
          He just loved the people in Kermis Club and Kermis Club loved him in return.  
"
            />
      </div>
     <br></br>
     <br></br>
      <div className={`whiteFancyHeadFontCenter`} >
      <h2>Michael Long</h2>
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={michaelLong}
          myText="Kermis Club is saddened to announce that we have lost long-time member, Michael Long, to Alzheimer’s disease. |
          Michael, along with his wife, Melissa, were active in Kermis Club for many years, always enthusiastic contributors 
          and willing to help in whatever capacity was needed.  |Michael and Melissa attended Kermis dinner-dances and supported 
          the Club right up until the very end.  |Michael was a loyal Aggie, bled maroon and white, and wore his Aggie ring 
          every day of his life. |While a successful and diligent entrepreneur, being previously awarded Steel Executive of the Year
          by the Association of Steel Distributors, Michael also enjoyed tennis and skiing, but he was happiest on the water.   
          |While he did rig his first sailboat with the main sail upside down, he quickly learned and often took family trips on 
          chartered sailboats serving as the Captain, and his family the compliant crew. |While it is with heavy hearts; 
          Kermis Club wishes Michael 'Fair Winds and Following Seas'. "
            />
      </div> 

    </div>
  )
};
   
export default AboutUs;